import React from 'react';
import { LexicalComposer } from '@lexical/react/LexicalComposer';
import { LineBreakNode } from 'lexical';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { ListItemNode, ListNode } from '@lexical/list';
import { CodeHighlightNode, CodeNode } from '@lexical/code';
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { HorizontalRuleNode } from '@lexical/react/LexicalHorizontalRuleNode';

import { ImageNode } from '../nodes/ImageNode';
import { CollapsibleContentNode } from '../nodes/CollapsibleContentNode';
import { CollapsibleContainerNode } from '../nodes/CollapsibleContainerNode';
import { CollapsibleTitleNode } from '../nodes/CollapsibleTitleNode';
import { HtmlNode } from '../nodes/html/HtmlNode';

import RichTextEditorTheme from './RichTextEditorTheme';

const editorConfig = {
  autoFocus: false,
  // The editor theme
  theme: RichTextEditorTheme,
  // Handling of errors during update
  onError(error) {
    console.log(error);
  },
  // Any custom nodes go here
  nodes: [
    LineBreakNode,
    HeadingNode,
    ListNode,
    ListItemNode,
    QuoteNode,
    CodeNode,
    CodeHighlightNode,
    TableNode,
    TableCellNode,
    TableRowNode,
    AutoLinkNode,
    LinkNode,
    ImageNode,
    HorizontalRuleNode,
    HtmlNode,
    CollapsibleContainerNode,
    CollapsibleTitleNode,
    CollapsibleContentNode,
  ],
};

export const emptyEditorState =
  '{"root":{"children":[{"children":[],"direction":null,"format":"","indent":0,"type":"paragraph","version":1}],"direction":null,"format":"","indent":0,"type":"root","version":1}}';

function loadEditorState(initialEditorState) {
  if (!initialEditorState) return emptyEditorState;

  try {
    const isValidJSON = JSON.parse(initialEditorState);

    if (!isValidJSON) return emptyEditorState;

    return initialEditorState;
  } catch (error) {
    return emptyEditorState;
  }
}

export default function BaseEditor({ children, value }) {
  return (
    <LexicalComposer
      initialConfig={{
        ...editorConfig,
        // The initial editor state
        editorState: loadEditorState(value),
      }}
    >
      {children}
    </LexicalComposer>
  );
}
